<template>
  <div v-if="!loading">
    <b-row>
      <b-col>
        <b-form-group :label="$t('field.company')">
          <multi-select
            v-model="company"
            :multiple="false"
            :options="companies"
            :allow-empty="false"
            :searchable="true"
            :placeholder="$t('actions.pick_company')"
            :show-labels="false"
            label="label"
            track-by="id"
            @input="updateCompany"
            disabled
          >
            <span slot="noOptions">{{ $t("messages.no_results") }}</span>
            <span slot="noResult">{{ $t("messages.no_results") }}</span>
          </multi-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="$t('field.sap_code')">
          <b-form-input
            v-model="item.sap_code"
            name="sap_code"
            type="text"
            required
            placeholder="12345"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group :label="$t('field.name')">
      <b-form-input
        v-model="item.name"
        name="name"
        type="text"
        required
        placeholder="Lorem ipsum set dolor"
      />
    </b-form-group>

    <b-row>
      <b-col>
        <b-form-group :label="$t('field.group')">
          <multi-select
            v-model="group"
            :multiple="false"
            :options="groups"
            :allow-empty="false"
            :searchable="true"
            :placeholder="$t('actions.pick_group')"
            :show-labels="false"
            label="label"
            track-by="id"
            @input="updateGroup"
          >
            <span slot="noOptions">{{ $t("messages.no_results") }}</span>
            <span slot="noResult">{{ $t("messages.no_results") }}</span>
          </multi-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="$t('field.nif')">
          <b-form-input
            v-model="item.nif"
            name="nif"
            type="number"
            required
            placeholder="123456789"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group :label="$t('field.address')">
      <b-form-input
        v-model="item.address"
        name="address"
        type="text"
        required
        placeholder="Lorem ipsum set dolor"
      />
    </b-form-group>
    <b-row>
      <b-col>
        <b-form-group :label="$t('field.zip_code')">
          <b-form-input
            v-model="item.zip_code"
            name="zip_code"
            type="text"
            required
            placeholder="1234-123"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="$t('field.locality')">
          <b-form-input
            v-model="item.locality"
            name="locality"
            type="text"
            required
            placeholder="Lorem"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
  <div v-else>
    <spinner />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import companiesApi from '@/api/companies'
import groupsApi from '@/api/groups'
import MultiSelect from 'vue-multiselect'

export default {
  components: {
    MultiSelect
  },
  watch: {
    '$store.state.company.activeCompany': {
      async handler() {
        this.loading = true

        await this.init()

        this.loading = false
      }
    }
  },
  data: () => ({
    loading: true,
    companiesApi,
    groupsApi,
    companies: [],
    company: null,
    groups: [],
    group: null
  }),
  computed: {
    ...mapGetters({
      item: 'form/fields',
      activeCompany: 'company/activeCompany'
    })
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      await Promise.all([this.getCompanies(), this.getGroups()])

      this.setCompany()
      this.setGroup()

      this.loading = false
    },
    async getCompanies() {
      try {
        const response = await this.companiesApi.all()

        if (response && response.data && response.data.list) {
          this.companies = response.data.list.map(item => ({
            id: item.id,
            label: item.name
          }))
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }
      } catch (e) {
        console.error(e)
      }
    },
    setCompany() {
      this.company = this.item.company_id
        ? this.companies.find(item => item.id === this.item.company_id)
        : this.companies.find(item => item.id === this.activeCompany.id)

      this.item.company_id = this.company.id

      if (this.company === undefined) {
        this.$toasted.error(
          this.$t('messages.not_found_foreign', {
            field: this.$t('field.company').toLowerCase()
          })
        )
      }
    },
    updateCompany(company) {
      this.item.company_id = company.id
    },
    async getGroups() {
      try {
        const response = await this.groupsApi.all()

        if (response && response.data && response.data.list) {
          this.groups = response.data.list.map(item => ({
            id: item.id,
            label: item.name
          }))
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }
      } catch (e) {
        console.error(e)
      }
    },
    setGroup() {
      this.group = this.item.group_id
        ? this.groups.find(item => item.id === this.item.group_id)
        : null

      if (this.group === undefined) {
        this.$toasted.error(
          this.$t('messages.not_found_foreign', {
            field: this.$t('field.group').toLowerCase()
          })
        )
      }
    },
    updateGroup(group) {
      this.item.group_id = group.id
    }
  }
}
</script>
